import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "audit-logs-list mb-2" }
const _hoisted_2 = {
  key: 0,
  class: "list-loading"
}
const _hoisted_3 = {
  key: 1,
  class: "list-loading"
}
const _hoisted_4 = { class: "list list-scrollbar" }

import ListHeader from '@/components/AuditLog/ListHeader.vue';
import ResizableList from '@/components/ResizableList.vue';
import ListRow from '@/components/AuditLog/ListRow.vue';
import auditLog from '@/types/responses/auditLog';
import i18n from "@/lang/i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'AuditLogList',
  props: {
    isLoading: { type: Boolean },
    isSearchCompleted: { type: Boolean },
    auditLogs: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.common.list.reading')), 1)
        ]))
      : (!props.isSearchCompleted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.common.list.runFilter')), 1)
          ]))
        : _createCommentVNode("", true),
    _createVNode(ResizableList, { scrollAreaSelector: ".list" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_table, null, {
            default: _withCtx(() => [
              _createVNode(ListHeader),
              _createVNode(ListRow, {
                isLoading: props.isLoading,
                auditLogs: props.auditLogs,
                isSearchCompleted: props.isSearchCompleted
              }, null, 8, ["isLoading", "auditLogs", "isSearchCompleted"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})